<template>
  <div>
    <div v-if="accountNumbers.length == 0">N/A</div>
    <div v-else>
      <div v-for="item in accountNumbers">
        {{ item.account_number }}
      </div>
    </div>
  </div>
</template>

<script>

  import lodash from 'lodash'

  export default {
    name: 'VendorAccount',
    props: {
      vendor: {
        type: String,
      },
      accounts: {
        type: Array,
      },
    },
    computed: {
      accountNumbers() {
        return lodash.filter(this.accounts, (account) => {
          return account.vendor == this.vendor;
        });
      },
    },
  }
</script>

